import _defineProperty from "/drone/src/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["headerNavigationLinksContext", "name", "onClick", "to", "href", "isActive"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useCallback } from 'react';
import { getWindow } from '../../../../../system/util/getWindow';
export var useHeaderNavigationLink = function useHeaderNavigationLink(_ref) {
  var headerNavigationLinksContext = _ref.headerNavigationLinksContext,
      name = _ref.name,
      onClick = _ref.onClick,
      to = _ref.to,
      href = _ref.href,
      isActive = _ref.isActive,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var onLinkClick = headerNavigationLinksContext.onLinkClick,
      locationTracking = headerNavigationLinksContext.locationTracking,
      pathname = headerNavigationLinksContext.pathname;
  var handleLinkClick = useCallback(function (event) {
    if (onClick) {
      onClick(event);

      if (event.isPropagationStopped()) {
        return;
      }
    }

    if (onLinkClick && name) {
      onLinkClick(name);
    }
  }, [onClick, onLinkClick, name]);
  var url = to || href;
  var isReallyActive = false;

  if (isActive !== undefined) {
    isReallyActive = isActive;
  } else if (locationTracking && url) {
    var win = getWindow();
    var currentPathname = pathname;

    if (currentPathname === undefined && win) {
      currentPathname = win.location.pathname;
    }

    if (currentPathname) {
      isReallyActive = currentPathname.startsWith(url);
    }
  }

  return {
    isActive: isReallyActive,
    onClick: handleLinkClick,
    restRootProps: _objectSpread({
      to: to,
      href: href
    }, restProps)
  };
};